import { render, staticRenderFns } from "./UpcomingNotification.vue?vue&type=template&id=e0e22c72"
import script from "./UpcomingNotification.vue?vue&type=script&lang=js"
export * from "./UpcomingNotification.vue?vue&type=script&lang=js"
import style0 from "./UpcomingNotification.vue?vue&type=style&index=0&id=e0e22c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports